/**
 * @fileoverview GET handler for the "/engagement/preset_iam_templates" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetIamTemplates } from "./constants";
import type { EngagementPresetIamTemplatesResult } from "./types";
import { isEngagementPresetIamTemplatesResult } from "./validators";

export const getDataTableEngagementPresetIamTemplates = reactQueryTableFetcherAdapter(
  engagementPresetIamTemplates,
  (signal: AbortSignal): Promise<EngagementPresetIamTemplatesResult> => {
    return fetch("/engagement/preset_iam_templates", "GET", {}, { signal });
  },
  isEngagementPresetIamTemplatesResult
);
